import React, {useState, useEffect} from 'react';
import {Grid} from '@material-ui/core/';
import {NavigateNext} from '@material-ui/icons';
import { useStyles } from "./style";
import {connect } from "react-redux";
import mapStateToProps from './mapStateToProps';
import mapDispatchToProps from './mapDispatchToProps';
import { useHistory } from "react-router-dom";
import Form from 'components/Form/FormTwoColumns';
import DatosCiudadano from './DatosCiudadano'
import {functions} from 'constants/index';
import ApiServices from 'services/ApiServices';
import {showMessagePersonalizedPosition} from 'services/SweetAlert'
import DialogLoadingMessage from 'components/BackDrop';

function DatosCiudadanoPortalWebTSE(props) {
    let history = useHistory();
    const [cargandoDatos, setCargandoDatos] = useState(true);
    const classes = useStyles(),
        [loadingMessage, setLoadingMessage] = useState({loading:false, title:''});
        let description = [
            {name: "- Antes de continuar, revise que la información que ingresó esté correcta.",},
            {name: "- Datos requeridos (*)."}
        ]
        let cenVotacion = '';
        let isReturn = false;
    const CentroDeVotacionParseada = (numero, cantidad) =>{
        return (numero).toString().padStart(cantidad,'0')
    } 
    //cargamos las comunidades
    const ObtenerComunidadesEnMemoria = (idDepartamentoResidencia, idMunicipioResidencia) =>{
        let newElements= Object. assign({}, elements);
        const currentMunicipality = props.catalogos?.comunidades?.filter( ({departamentoId, municipioId}) => Number(departamentoId) === Number(idDepartamentoResidencia) && Number(municipioId) === Number(idMunicipioResidencia));
        if(currentMunicipality?.length > 0) {
            newElements.comunidad.list=currentMunicipality;
            setElements(newElements);
            setLoadingMessage({loading: false, title:''})
            return true;
        } else return false;
    }
    const setComunidad =async (event)=>{
        setLoadingMessage({loading: true, title:'Cargando comunidades. Espere un momento ...'})
        let newElements= Object. assign({}, elements); 
        isReturn = ObtenerComunidadesEnMemoria(props.datosPortalWeb.departamentoResidencia?.id, props.datosPortalWeb.municipioResidencia?.id?.id)
        if(isReturn){
            setLoadingMessage({loading: false, title:''})
            return;
        }else{            
            try{
                ApiServices.comunidades.searchCriteria.clear();
                ApiServices.comunidades.searchCriteria.setOperator("and");
                ApiServices.comunidades.searchCriteria.addEquals("departamentoId", props.datosPortalWeb.departamentoResidencia?.id);
                ApiServices.comunidades.searchCriteria.addEquals("municipioId", props.datosPortalWeb.municipioResidencia?.id?.id);
                let response =await ApiServices.comunidades.listRegisterCriteria();
                if(response.error){
                    showMessagePersonalizedPosition('warning','Oopss!', response.error.message,'center')
                    newElements.comunidad.list=[];
                }else {                
                    newElements.comunidad.list=response.data;
                    props.SOLICITUD_EMPADRONAMIENTO_SET_CATALOGOS_COMUNIDAD(response.data)
                }
            }catch(exception){
                if (exception.status===404) {
                    showMessagePersonalizedPosition('error', '¡Oops!', "Falla del Sistema. Ponganse en contacto con el Administrador sí este mensaje persiste.", 'center')
                }
                else {
                    showMessagePersonalizedPosition('error', '¡Oops! ', "Intente de nuevo. Ponganse en contacto con el Administrador sí este mensaje persiste.", 'center')
                }            
                newElements.comunidad.list=[];
            }
        }        
        setElements(newElements);
        setLoadingMessage({loading: false, title:''})
    };
    const ObtenerCentroVotacionDeLaComunidad = () =>{
        let datos = elements.comunidad.list
        Object.keys(datos).forEach((element, key, _array) =>{
            if(datos[element].id === elements.comunidad.value?.id){
                cenVotacion = datos[element].centroVotacionId
            }
        }) 
    }  
    const ObtenerCodigoGeolectoralSeleccionado = (comunidad) =>{
        var datos = elements.comunidad.list, centroDeVotacion='';
        let newElements= Object. assign({}, elements); 

        Object.keys(datos).forEach((element, key, _array) =>{
            if(datos[element].id === comunidad?.target?.value){
                centroDeVotacion = datos[element].centroVotacionId
                newElements.comunidadCodigoGeoelectoral.value={title: 'Comunidad', value: CentroDeVotacionParseada(comunidad?.target?.value, 4)}
                newElements.centroVotacionCodigoGeoelectoral.value={title: 'Centro de Votación', value: CentroDeVotacionParseada(centroDeVotacion, 4)}
                setElements(newElements);              
            }
        })
        if(newElements.comunidad.value?.id === undefined || newElements.comunidad.value?.id === 0) {
            newElements.comunidadCodigoGeoelectoral.value={title: 'Comunidad', value: ''}
            newElements.centroVotacionCodigoGeoelectoral.value={title: 'Centro de votación', value: ''}
            setElements(newElements);              
        }        
    }
    const [elements,setElements] = useState({
    residenciaElectoralActualEnElPadron:{
        idelement: "residenciaElectoralActualEnElPadron", title:'RESIDENCIA ELECTORAL ACTUAL EN EL PADRON', validators: ['requireds'], position:"left", value: "", currentValue:"", isError:false, elementType:'customTitle',
    },
        nombreCompletoResidenciaActualEnElPadron: {
            idelement: "nombreCompletoResidenciaActualEnElPadron",  value:"", label: "Nombre", pattern:"", validators: ['requireds'], finalRequiredLength: 0,
            errorMessages:[''], isError:false, elementType:'textField', disabled: 'true'
        },
        numeroBoletaResidenciaActualEnElPadron: {
            idelement: "numeroBoletaResidenciaActualEnElPadron",  value:"", label: "Número de boleta", pattern:"", validators: ['requireds'], finalRequiredLength: 0,
            errorMessages:[''], isError:false, elementType:'textField', disabled: 'true'
        },
        departamentoResidenciaActualEnElPadron: {
            idelement: "departamentoResidenciaActualEnElPadron", value: null, label: "Departamento Residencia *", pattern:"", validators: ['requireds'], disabled: true,
            errorMessages:['Seleccione el Departamento Residencia'], isError:false, elementType:'autocompleteV2', list: [], variant:'outlined'
        },
        municipioResidenciaActualEnElPadron: {
            idelement: "municipioResidenciaActualEnElPadron", value: null, label: "Municipio Residencia *", pattern:"", validators: ['requireds'], disabled: true,
            errorMessages:['Seleccione el Municipio Residencia'], isError:false, elementType:'autocompleteV2', list: [], variant:'outlined'
        },                
        comunidadResidenciaActualEnElPadron: {  
            idelement: "comunidadResidenciaActualEnElPadron",  value: null, label: "Comunidad Residencia*", pattern:"", validators: ['requireds'], errorMessages:['Comunidad requerida'], 
            isError:false, elementType:'autocompleteV2', list: [],  variant:'outlined', disabled: true,
        },        
        direccionResidenciaActualEnElPadron: {
            idelement: "direccionResidenciaActualEnElPadron",  value:"", label: "Dirección", pattern:"", validators: ['requireds'], finalRequiredLength: 0,
            errorMessages:[''], isError:false, elementType:'textField', disabled: 'true'
        },
        noCasaLoteResidenciaActualEnElPadron: {
            idelement: "noCasaLoteResidenciaActualEnElPadron",  value:"", label: "No. Casa/Lote", pattern:"", validators: ['requireds'], finalRequiredLength: 0,
            errorMessages:[''], isError:false, elementType:'textField', disabled: 'true'
        },
        zonaResidenciaActualEnElPadron: {
            idelement: "zonaResidenciaActualEnElPadron",  value:"", label: "Zona", pattern:"", validators: ['requireds'], finalRequiredLength: 0,
            errorMessages:[''], isError:false, elementType:'textField', disabled: 'true'
        },                
    titleCampos:{ idelement: "titleCampos", validators: ['requireds'], title:'Complete los campos', position:"left", value: "", isError:false, elementType:'customTitle'},        
        departamento: {
            idelement: "departamento", value: props.datosPortalWeb.departamentoResidencia , label: "Departamento Residencia *", pattern:"^[1-9][0-9]*$", validators: ['required'], disabled: true,
            errorMessages:['Seleccione el Departamento Residencia'], isError:false, elementType:'autocompleteV2', list: [], position: props.datosPortalWeb.departamentoResidencia?.id-1, variant:'outlined'
        },
        municipio: {
            idelement: "municipio", value: props.datosPortalWeb.municipioResidencia, label: "Municipio Residencia *", pattern:"^[1-9][0-9]*$", validators: ['required'], disabled: true,
            errorMessages:['Seleccione el Municipio Residencia'], isError:false, elementType:'autocompleteV2', list: [], position: props.datosPortalWeb.municipioResidencia?.id?.id-1, variant:'outlined'
        },                
        comunidad: {  
            idelement: "comunidad",  value: null, label: "Comunidad Residencia*", pattern:"^[\\w\\s]{1,}$", validators: ['required'], errorMessages:['Comunidad requerida'], 
            isError:false, elementType:'autocompleteV2', list: [], variant:'outlined', handler: ObtenerCodigoGeolectoralSeleccionado,
        },
        direccion: {
            idelement: "direccion",  value: '', label: "Dirección Residencia *", pattern:"^([-\\w_ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()][-\\w_ .\"\'ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()]*[-\\w_.\"\'ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()]){0,50}$", 
            validators: ['required'], errorMessages:['Ingrese Dirección Residencia, Máximo 50 carácteres, sin espacios al inicio y final'], isError:false, elementType:'textField', showInputControl: true, finalRequiredLength: 50
        },
        numeroCasa: {
            idelement: "numeroCasa",  value:"", label: "No. Casa/Lote", pattern:"^([-\\w_ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()][-\\w_ .\"\'ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()]*[-\\w_.\"\'ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()]){0,10}$", validators: ['requireds'], finalRequiredLength: 10,
            errorMessages:['No. Casa/Lote - Máximo 10 carácteres, sin espacios al inicio y final'], isError:false, elementType:'textField',
        },
        numeroZona: {
            idelement: "numeroZona",  value:"", label: "Zona", pattern:"^[0-9]{0,2}]*$", validators: ['requireds'], errorMessages:['Zona - Máximo 2 carácteres, sin espacios al inicio y final'], 
            isError:false, elementType:'textField', finalRequiredLength: 2, type: 'number' 
        },
        codigoGeoelectoral:{
            idelement: "codigoGeoelectoral", title:'Código GeoElectoral', position:"left", value: "", isError:false, elementType:'customTitle', validators: ['requireds']
        },
            departamentoCodigoGeoelectoral:{
                idelement: "departamentoCodigoGeoelectoral", position:"center",  isError:false, elementType:'labelWithTitleAndSubtitle',
                value: {title: 'Departamento', value:''}, validators: ['requireds'], show: true,
            },
            municipioCodigoGeoelectoral:{
                idelement: "municipioCodigoGeoelectoral", position:"center",  isError:false, elementType:'labelWithTitleAndSubtitle',
                value: {title: 'Municipio', value:''} , validators: ['requireds'], show: true,
            },
            comunidadCodigoGeoelectoral:{
                idelement: "comunidadCodigoGeoelectoral", position:"center",  isError:false, elementType:'labelWithTitleAndSubtitle',
                value: {title: 'Comunidad', value:''}, validators: ['requireds'], show: true,
            },
            centroVotacionCodigoGeoelectoral:{
                idelement: "centroVotacionCodigoGeoelectoral", position:"center",  isError:false, elementType:'labelWithTitleAndSubtitle',
                value: {title: 'Centro de Votación', value:''}, validators: ['requireds'], show: true,
            },
    titleObservacion:{
        idelement: "titleObservacion",title:'Observaciones', position:"left", value: "", isError:false, elementType:'customTitle', validators: ['requireds'],
    },    
        observaciones: {
            idelement: "observaciones",  value:'', label: "Observación", pattern:"^([\\w_ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()][\\w_ -.\"\'ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()]*[\\w_.\"\'ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()]){0,2}$", minWidth: 1100,
            validators: ['requireds'], errorMessages:['Máximo 1024 carácteres, sin espacios al inicio y final'], isError:false, elementType:'textareaV2', showInputControl: true, maxLength: 1024
        },    
    titlecContraseña:{ idelement: "titlecContraseña", title:'Ingrese la contraseña de firma electrónica', validators: ['requireds'], isError:false, position:"left", value: "", isError:false, elementType:'customTitle'},        
        contraseña: {  
            idelement: "contraseña",  value:'', label: "Contraseña *", finalRequiredLength: 50,
            pattern:"^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[$@#$!¡:.;{}+=^~|%*¿?&/-])[A-Za-z\\d$@#$!¡:.;{}+=^~|%*¿?&/-]\\S{6,50}$", validators: ['required'], 
            errorMessages:['Contraseña requerida'], isError:false, elementType:'password' , variant:'outlined'
        },
    });
    // limpiar datos de la residencia electoral
    const limpiarDatosResidenciaElectoralActual = () => {
        elements.nombreCompletoResidenciaActualEnElPadron.value = ''
        elements.numeroBoletaResidenciaActualEnElPadron.value = ''
        elements.departamentoResidenciaActualEnElPadron.value = null
        elements.municipioResidenciaActualEnElPadron.value = null
        elements.comunidadResidenciaActualEnElPadron.value = null
        elements.direccionResidenciaActualEnElPadron.value = ''
        elements.noCasaLoteResidenciaActualEnElPadron.value = ''
        elements.zonaResidenciaActualEnElPadron.value = ''
    }

    useEffect(() => {
        if(props.residenciaPadron?.status){
            elements.nombreCompletoResidenciaActualEnElPadron.value = props.residenciaPadron?.name || ''
            elements.numeroBoletaResidenciaActualEnElPadron.value = props.residenciaPadron?.numeroBoleta || ''
            elements.departamentoResidenciaActualEnElPadron.value = props.residenciaPadron?.departamentoDeResidencia || ''
            elements.municipioResidenciaActualEnElPadron.value = props.residenciaPadron?.municipioDeResidencia
            elements.comunidadResidenciaActualEnElPadron.value = props.residenciaPadron?.comunidadResidencia || ''
            elements.direccionResidenciaActualEnElPadron.value = props.residenciaPadron?.direccion || ''
            elements.noCasaLoteResidenciaActualEnElPadron.value = props.residenciaPadron?.numeroDeCasa || ''
            elements.zonaResidenciaActualEnElPadron.value = props.residenciaPadron?.numeroDeZona || ''
            setCargandoDatos(false)
        } else if(props.residenciaPadron?.status === false){
            limpiarDatosResidenciaElectoralActual()
            setCargandoDatos(false)
        }
    },[props.residenciaPadron?.status])

    const validarIsError = ()=>{
        let esError = false
        var BreakException = {};
        try {
            Object.keys(elements).map((key) => {
                if(elements[key].isError){
                    esError = true                    
                    throw BreakException
                }
            })
        } catch (e) {
            if (e !== BreakException) throw e;
        }
        if(esError) return true;
        else return false;
    }
    const validarComunidadCentroVotacion = (data) =>{
        if( (data.comunidad === null || data.comunidad === '' || data.comunidad === undefined) || (data.cenVotacion === null || data.cenVotacion === '' || data.cenVotacion === undefined)){
            elements.comunidad.value = null
            setLoadingMessage({loading: false, title:''})
            showMessagePersonalizedPosition('warning', 'Advertencia' ,'No se obtuvo comunidad o centro de votación, por favor borre la comunidad y vuelva a seleccionarla.')
            return true;
        }
    }      
    const ProcesarSolicitudPortalWeb= async()=>{
        let allGood = true;
        allGood = functions.checkIsEmptyWhenRequiredElement(
            elements,
            setElements
        );
        if(validarIsError()) return;
        if(allGood){
            setLoadingMessage({loading: true, title:'Procesando solicitud. Espere un momento ...'})
            if(elements.comunidad.value === '') {
                let newElements= Object. assign({},)
                
                elements.comunidad.isError = true
            }
            ObtenerCentroVotacionDeLaComunidad()
            let saveData = {
                idSolicitud: props.datosPortalWeb.idSolicitud,
                departamento: elements.departamento.value.id,
                municipio: elements.municipio.value.id.id,
                comunidad: elements.comunidad.value?.id,
                cenVotacion: cenVotacion,
                numeroCasa: elements.numeroCasa.value,
                numeroZona: elements.numeroZona.value,
                // direccion:props.datosPortalWeb.direccion,
                nroBoleta: props.estadoPadronDelCiudadanoEstaEmpadronado || '',
                direccion:elements.direccion.value,
                base64ConstanciaParaHuella: "",
                codigoCVE: "",
                password: elements.contraseña.value,
                observaciones: elements.observaciones.value ? elements.observaciones.value.trim() : '',
            }
            if (validarComunidadCentroVotacion(saveData)) return;      
            try {
                const response = await ApiServices.verificarSolicitudDeEmpadronamiento.autorizar(saveData)
                if(response.error){
                    showMessagePersonalizedPosition('warning','Oopss!', response.error.message,'center')
                }else {
                    elements.departamento.value = ''
                    elements.municipio.value = ''
                    elements.comunidad.value = ''
                    elements.observaciones.value = ''
                    elements.direccion.value = ''
                    elements.contraseña.value = ''
                    elements.numeroCasa.value = ''
                    elements.numeroZona.value = ''
                    props.SOLICITUD_EMPADRONAMIENTO_SET_STEP_PORTAL_WEB(0);    
                    props.actualizarTabla()
                    Cerrar()
                    showMessagePersonalizedPosition(response.data.tipo, ((response.data.tipo === "success") ? "¡BIEN!" : (response.data.tipo === "warning") ? "Advertencia": ''), response.data.message);
                    // showMessagePersonalizedPosition('success','BIEN!', response.data.message,'center')
                }             
            } catch (exception) {
                if (exception.status===404) {
                    showMessagePersonalizedPosition('error', '¡Oops!', "Falla del Sistema. Ponganse en contacto con el Administrador sí este mensaje persiste.", 'center')
                }
                else {
                    showMessagePersonalizedPosition('error', '¡Oops! ', "Intente de nuevo. Ponganse en contacto con el Administrador sí este mensaje persiste.", 'center')
                }           
            }     
            setLoadingMessage({loading: false, title:''})
        }
    };   

    // PREGUNTAR SI SE PUEDE CERRAR O SI SE PUEDE ELIMINAR LA INFORMACION AL VOLVER AL HOMONIMO
    const Cerrar=()=>{        
        functions.clearElementValues(elements, setElements);
        props.handleClose()     
    };    

    const CancelarSolicitud=()=>{
        props.SOLICITUD_EMPADRONAMIENTO_SET_RECHAZAR_SOLICITUD_PORTAL_WEB(true)
        props.SOLICITUD_EMPADRONAMIENTO_SET_STEP_PORTAL_WEB(props.stepPortalWeb+1);
    };

    const Regresar=()=>{
        props.SOLICITUD_EMPADRONAMIENTO_SET_STEP_PORTAL_WEB(props.stepPortalWeb-1);
    }

    useEffect(() => {
        if(props.open) {
            (async () => {
                await setComunidad();
            })();
        }
    }, [props.open]);

    useEffect(() => {
            let newElements= Object. assign({}, elements); 
            newElements.departamentoCodigoGeoelectoral.value={title: 'Departamento', value: CentroDeVotacionParseada(props?.datosPortalWeb?.departamentoResidencia?.id, 2)}
            newElements.municipioCodigoGeoelectoral.value={title: 'Municipio', value: CentroDeVotacionParseada(props?.datosPortalWeb?.municipioResidencia?.id?.id, 2)}
            setElements(newElements);        
    }, [props.datosPortalWeb]);

    return (
        <div className={classes.root}>
            <DialogLoadingMessage open={loadingMessage.loading} title={loadingMessage.title}/>
            <div className={classes.colorComponente}>
                <Grid >
                    <Grid className={classes.marginText} item xs={12} > 
                        <DatosCiudadano {...props} cuiDPI={props.cuiDPI} open={props.open}/>
                    </Grid>
                </Grid><br/>
                <div className={classes.lineaDegradadaBottom}></div>
            </div> <br/>
            <div  className={classes.colorComponente}>
                <Grid container >
                    <Grid className={classes.AlignTable} item xs={12}>
                        {
                            !cargandoDatos ? 
                                <Form   elements= {elements} BotonCerrar={Cerrar} BotonRegresar={Regresar}
                                    BotonCancelar={CancelarSolicitud} description={description} MensajeDatosRequeridos={'Datos requeridos (*)'}
                                    disabled={loadingMessage.loading} loading={loadingMessage.loading} BotonProcesar={ProcesarSolicitudPortalWeb}
                                />
                            : <DialogLoadingMessage open={cargandoDatos} title={'Cargando datos ...'}/>
                        }
                    </Grid>                                       
                </Grid><br/>
                <div className={classes.lineaDegradadaBottom}></div>
            </div><br/>
        </div>
    );
}


export default connect(mapStateToProps, mapDispatchToProps)(DatosCiudadanoPortalWebTSE);